import { merge as objectMapper } from 'object-mapper';

import dayjs, { DATE_FORMAT } from 'utils/dayjs';

import type { GetCollectionOrdersParams } from 'api';

import type { DateRangeFilter } from 'reduxLocal/slices/globalFiltersSlice';

import type { LocalState } from './localState';

type Params = LocalState & { dateRange: DateRangeFilter } & {
  organisation_id: string;
};

export const apiParams = function (params: Params): GetCollectionOrdersParams {
  // The endpoint does not accept 'All' as a query param, so we need to send undefined in that case
  const filteredParams: Params = {
    ...params,
    filters: {
      ...params.filters,
      accountNumber:
        params.filters.accountNumber === 'All'
          ? undefined
          : params.filters.accountNumber,
      status:
        params.filters.status === 'All' ? undefined : params.filters.status
    }
  };

  const map = {
    organisation_id: 'organisation_id',
    'dateRange.from': [
      {
        key: 'created_after',
        default: dayjs().subtract(30, 'days').startOf('day').format(DATE_FORMAT)
      }
    ],
    'dateRange.to': [
      {
        key: 'created_before',
        default: dayjs().add(1, 'days').endOf('day').format(DATE_FORMAT)
      }
    ],
    'filters.status': 'status',
    'filters.accountNumber': 'virtual_account_number',
    'filters.reason_code_id': 'reason_code_id',
    sort: 'meta.sort',
    cursorAfter: 'meta.cursor_after',
    cursorBefore: 'meta.cursor_before'
  };
  return objectMapper(filteredParams, map) as GetCollectionOrdersParams;
};
